import { DEFAULT_LANG } from '../../../lib/locale'
import en from './en.js'
import de from './de.js'
import es from './es.js'
import fr from './fr.js'
import it from './it.js'
import pl from './pl.js'
import pt from './pt.js'

const TRANSLATIONS = { en, de, es, fr, it, pl, pt }

// App Store reviewer names, in display order. Review text lives in the
// per-language files above, keyed by the same id.
const REVIEWERS = [
    { id: 'r1', name: "Matt" },
    { id: 'r2', name: "Michelle" },
    { id: 'r3', name: "Anni" },
    { id: 'r4', name: "James" },
    { id: 'r5', name: "Chris" },
    { id: 'r6', name: "Dave" },
    { id: 'r7', name: "Thomas" },
    { id: 'r8', name: "Michelle" },
    { id: 'r9', name: "Raffy2017" },
    { id: 'r10', name: "OlgsLandscape" },
    { id: 'r11', name: "Brambo of Salopia" },
]

export const getReviews = (lang) =>
    REVIEWERS.map(({ id, name }) => ({
        name,
        review: TRANSLATIONS[lang]?.[id] || TRANSLATIONS[DEFAULT_LANG][id],
    }))
